import { useState, useCallback } from 'react';
import Axios from '../../config/axios';
import { UrlConstant } from '../UrlConstant';

export const useDocumentPassword = () => {
    const [password, setPassword] = useState<string | null>(null);

    const fetchPassword = useCallback(async (): Promise<string | null> => {
        if (password) return password; // cache for the session
        try {
            const response = await Axios.get(UrlConstant.User.GetDocumentPassword);
            const pwd = response.data?.data?.password ?? null;
            setPassword(pwd);
            return pwd;
        } catch (error) {
            console.error('Failed to fetch document password:', error);
            return null;
        }
    }, [password]);

    return { password, fetchPassword };
};